import { Injectable, Injector, ErrorHandler} from '@angular/core';
import { MdlSnackbarService, IMdlDialogAction } from '@angular-mdl/core';
import { SnackbarService, SnackbarAction } from '..//shared/snack-bar/snack-bar.service';
import { Location } from '@angular/common';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {

    constructor(private injector: Injector, private location: Location, private snackbarService: SnackbarService) {
        super();
    }

    public handleError(error: any) {
        try {
            const errorCode = this.getErrorCode(error);

            if (errorCode === 401 || errorCode === 403) {
                this.redirectToErrorPage(errorCode);
            } else if (errorCode === 404) {
                this.showWarningNotification('One of resources you requested is not found, please contact your system administrator.');
            } else {
                this.showMultipleActionWarningNotification('An error occurred, please refresh the page and try again or contact your system administrator.', [
                    {
                        label: 'REFRESH',
                        handler: () => window.location.reload()
                    },
                    {
                        label: 'DISMISS',
                        handler: () => { }
                    }
                ]);
            }
        } catch (innerError) {
            super.handleError(innerError);
        }

        super.handleError(error);
    }

    public displayErrorMsg(message: string, customAction?: IMdlDialogAction) {
        return this.showDismissNotification(message, customAction);
    }

    private getErrorCode(error: any) {
        if (error) {
            if (error.status) {
                return error.status;
            }

            if (error.rejection && error.rejection.status) {
                return error.rejection.status;
            }
        }

        return null;
    }

    private showDismissNotification(message: string, customAction?: IMdlDialogAction) {
        const mdlSnackbarService = this.injector.get(MdlSnackbarService) as MdlSnackbarService;
        return mdlSnackbarService.showSnackbar({
            message: message,
            closeAfterTimeout: false,
            action: customAction
        });
    }

    private showWarningNotification(message: string, customAction?: IMdlDialogAction): void {
        const mdlSnackbarService = this.injector.get(MdlSnackbarService) as MdlSnackbarService;
        mdlSnackbarService.showSnackbar({
            message: message,
            closeAfterTimeout: false,
            action: customAction
        });
    }

    private showMultipleActionWarningNotification(message: string, customActionList: SnackbarAction[] = []): void {
        this.snackbarService.showSnackbar(message, customActionList);
    }

    private redirectToErrorPage(errorCode: string): void {
        window.location.href = this.location.prepareExternalUrl(`/error/${errorCode}`);
    }
}   